var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "cake_today_config",
      attrs: {
        disabled: _vm.disabled,
        model: _vm.value.config,
        rules: _vm.rules,
      },
    },
    [
      _c("div", { staticClass: "tips" }, [
        _vm._v(
          " 当日达组件默认展示全部支持当日达的蛋糕商品，定位或所选城市不支持当日达时自动隐藏 "
        ),
      ]),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "category_id" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择菜单", filterable: "" },
                  model: {
                    value: _vm.value.config.category_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "category_id", $$v)
                    },
                    expression: "value.config.category_id",
                  },
                },
                _vm._l(_vm.menuList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.show_name,
                      value: item.id,
                      disabled: item.disabled,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c("el-form-item", { attrs: { prop: "imageurl" } }, [
            _c("div", { staticClass: "upload-item-wrap" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("upload-file", {
                    ref: "uploadBanner",
                    attrs: {
                      "link-url": _vm.linkUrl,
                      tempurl: _vm.value.config.imageurl,
                      canDel: Boolean(_vm.value.config.imageurl),
                      deletePadding: true,
                      uploadInfo: _vm.uploadInfo,
                    },
                    on: {
                      onDelete: _vm.deleteImg,
                      emitUploadFile: _vm.emitUploadFile,
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c(
                    "el-button",
                    { staticStyle: { margin: "0" }, on: { click: _vm.upload } },
                    [_vm._v("上传图片")]
                  ),
                  _vm.pictureList.length > 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.selectPicture },
                        },
                        [_vm._v(" 选择图片 ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "tips" }, [
            _vm._v(" 建议尺寸为690*153，支持JPG、PNG等格式，大小不超过2M "),
          ]),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }